import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import LeftArrow from '../../images/dropdown_arrow_copy.svg';
import RightArrow from '../../images/dropdown_arrow.svg';

const DatePickerStyled = styled.div`

    color: #3E2723;
    position: relative;
    z-index: 1;
    
    .transition, .focused, .error {
        top: 15px;
        font-size: 10.5px;
    }
    
    .focused {
        color: #04A2DC;
    }
    
    .error {
        color: #CD2028;
    }
    
    .DayPickerInput {
        width: 100%;
        position: relative;
        margin-bottom: 5px;
        margin-top: 28px;
        
        input {
            width: 100%;
            line-height: 26px;
            background: transparent;
            border: none;
            border-bottom-width: 1px;
            border-bottom-style: solid;
            border-bottom-color: ${props => props.error ? '#CD2028' : '#bcaaa3'};
            border-radius: 0;
            box-shadow: none;
            padding: 10px 13px 3px 13px;
            font-family: IntroBold;
            font-size: 17.5px;
            color: #3e2723;
        }
        
        .DayPickerInput-OverlayWrapper {
            width: 100%;
            font-family: IntroBold;
            
            .DayPickerInput-Overlay {
                width: 100%;
                text-align: center;
                background: white;
                
                .DayPicker {
                    width: 100%;
                    
                    .DayPicker-wrapper {
                        z-index: 1;
                        background: white;
                        border-radius: 2px;
                        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);
                        
                        .DayPicker-NavBar {
                            width: 301px;
                            left: inherit;
                            right: inherit;
                            top: 25px;
                            
                            button {
                               background: none;
                               border: none;
                            }
                        }
                        
                        .DayPicker-Month {
                            display: flex;
                            flex-direction: column;
                            
                            .DayPicker-Caption {
                                display: inherit;
                                align-items: center;
                                justify-content: center;
                                text-align: center;
                                font-size: 16px;
                                text-transform: uppercase;
                                letter-spacing: 0;
                                line-height: 20px;
                                padding-top: 28px;
                                padding-bottom: 22px;
                            }
                            
                            .DayPicker-Weekdays {
                                display: flex;
                                
                                .DayPicker-WeekdaysRow {
                                    display: inherit;
                                    flex: 1;
                                    .DayPicker-Weekday {
                                        flex: 1;
                                        align-items: center;
                                        justify-content: center;
                                        font-size: 13px;
                                        color: #C5B3AF;
                                    }
                                }
                            }
                            
                            .DayPicker-Body {
                                display: flex;
                                flex-direction: column;
                                
                                .DayPicker-Week {
                                    display: flex;
                                    
                                    .DayPicker-Day {
                                        display: flex;
                                        flex: 1;
                                        justify-content: center;
                                        align-items: center;
                                        width: 40px;
                                        height: 40px;
                                        padding: 0;
                                        border: 7px solid white;
                                        border-radius: 50%;
                                        font-size: 13px;
                                        &:hover {
                                           background-color: #C5B3AF;
                                           color: #3E2723;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
     
    .DayPicker-Day--today {
        color: #3e2723;
        font-weight: normal;
    }
    
    .DayPicker-Day--outside {
        color: #C5B3AF;
    }
    
    .DayPicker-Day--selected {
        background-color: #3e2723 !important;
    }
`;

const LabelStyled = styled.label`
    position: absolute;
    left: 13px;
    top: 40px;
    font-size: 14px;
    color: #bcaaa3;
    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const ErrorSpanStyled = styled.span`
    display: ${props => props.show ? 'inline' : 'none'};
    text-transform: capitalize;
    color: inherit;
    font-weight: 400;
`;

const Weekday = ({ weekday, className, localeUtils, locale }) => {
    const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
    return (
        <div className={className} title={weekdayName}>
            {weekdayName.slice(0, 1)}
        </div>
    );
};

const Navbar = ({ onPreviousClick, onNextClick, className }) => {
    const styleLeft = {
        float: 'left'
    };
    const styleRight = {
        float: 'right'
    };
    return (
        <div className={className}>
            <button style={styleLeft} onClick={() => onPreviousClick()}>
                <img alt="left" src={LeftArrow}/>
            </button>
            <button style={styleRight} onClick={() => onNextClick()}>
                <img alt="right" src={RightArrow} />
            </button>
        </div>
    );
};

class DatePicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            day: props.selectedDay ? props.selectedDay.format('MM/DD/YYYY') : '',
            inputFocused: false
        };
    }

    styleLabel = () => {
        this.setState({ inputFocused: true });
    };

    handleDayChange = (moment) => {
        if (moment) {
            const day = moment.format('MM/DD/YYYY');
            this.setState(
                { day, inputFocused: false },
                this.props.handleDayChange(day)
            );
        }
    };

    render() {
        const dayPickerProps = {
            weekdayElement: <Weekday />,
            navbarElement: <Navbar />
        };

        const transition = (!!this.state.day || this.props.error) ? 'transition' : '';

        const focused = this.state.inputFocused ? 'focused' : '';

        const error = this.props.error ? 'error' : '';

        return (
            <DatePickerStyled error={this.props.error}>
                <DayPickerInput id="day_picker_custom"
                                onFocus={() => {
                                    this.setState({ inputFocused: true });
                                }}
                                onBlur={() => {
                                    this.setState({ inputFocused: false });
                                }}
                                name="day"
                                placeholder=''
                                format="MM/DD/YYYY"
                                value={this.state.day}
                                onDayChange={this.handleDayChange}
                                dayPickerProps={dayPickerProps}/>

                <LabelStyled className={`${focused} ${transition} ${error}`}
                             htmlFor="day_picker_custom" >
                    {`${this.props.placeholderText} `}
                    <ErrorSpanStyled show={this.props.error}>
                        {this.props.getLocalizedText('Required', 'required')}
                    </ErrorSpanStyled>
                </LabelStyled>
            </DatePickerStyled>
        );
    }

}

DatePicker.propTypes = {
    placeholderText: PropTypes.string,
    selectedDay: PropTypes.string,
    handleDayChange: PropTypes.func.isRequired,
    getLocalizedText: PropTypes.func.isRequired
};

DatePicker.defaultProps = {
    placeholderText: 'placeholder',
    selectedDay: null,
    handleDayChange: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js